import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllTransactionsService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const accountName = urlQueries["account_name"] || "";
  const paymentType = urlQueries["payment_type"] || "";
  const created_between = urlQueries["created_between"] || "";
  const allTransactionsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.TRANSACTIONS,
      page,
      per_page,
      debouncedQuery,
      accountName,
      paymentType,
      created_between,
      ...cacheKeys,
      JSON.stringify(filters),
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.TRANSACTIONS,
        searchParams: {
          "filter[account.name]": debouncedQuery || accountName,
          "filter[created_between]": created_between,
          "filter[type]": paymentType,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    service: { allTransactionsService },
    states: { searchQuery, setSearchQuery },
  };
};
